<template>
    <div id="Container_ePharmacyItemsReceivedList">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="$t('ePharmacyItemsReceivedList.Title')" />  
            </b-col>
        </b-row>
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdButton
                    v-bind:Label="$t('ePharmacyItemsReceivedList.AddItemReceived')" 
                    v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="AddItemReceived"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Name="'btn_add_item_received'">
                </MdButton>
            </b-col>
            <b-col md="9" lg="9" sm="12">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="parameter.SearchCriteria"
                            @keyup.enter="SearchItemsReceived" />

                        <div class="input-group-append">
                            <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'" v-on:click="SearchItemsReceived">
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime 
                    :Label="$t('Shared.datefrom')" 
                    :Model="DateFrom"                           
                    @input="DateFrom = $event"                            
                    :Id="'ItemReceivedDateFrom'"
                    :Type="'date'"
                    :OnPressEnter="SearchItemsReceived"
                    :isRequired="false"                           
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateFromValid">
                </MdDateTime>       
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime 
                    :Label="$t('Shared.dateTo')"                             
                    :Model="DateTo"
                    @input="DateTo = $event"                                 
                    :Id="'ItemReceivedDateTo'"
                    :Type="'date'"
                    :OnPressEnter="SearchItemsReceived" 
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateToValid">
                </MdDateTime>
            </b-col>     
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Options="pharmacyLocations"
                    v-bind:Model="locationModel"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="true"
                    :Input="ChangeDropDownLocation"
                    v-bind:Name="'note_types_select'"
                    id="note_types_select"
                />									
            </b-col>  
             <b-col lg="3" md="3" sm="12">
                <MdLookupMultiSelect
                    v-bind:Label="$tc('ePharmacyItemsReceived.Item',2)"
                    v-bind:ModelCode="ItemCodeModel"
                    v-bind:RefCode="'Drugs'"
                    v-bind:Api="'ItemReceivedHeaders/InvetoryItems'"
                    v-bind:FieldCode="'itemCode'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$tc('ePharmacyItemsReceived.Item',2)"
                    :GetValues="getValuesItems"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'itemCode'"
                    :ServerSidePagination="true"
                    v-bind:Fields="BaseFields"
                />
            </b-col>
        </b-row>
         <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="mt-3 text-right">
                    <button 
                        v-on:click="SearchItemsReceived"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput">
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>
            
        <b-row>
            <b-col lg="12" md="12" sm="12" class="mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <b-row>
                    <b-col md="12">
                        <MdTable 
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :editIconEvent="EditItemReceived"
                            v-bind:VisibleEditIcon="true"
                            v-bind:VisibleDeleteIcon="false"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                            :FieldsDate="fieldsDate"
                            :otherIcon="'printer-fill'"
                            :otherIconEvent="showReport"
                        >                
                        </MdTable>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        
        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:isReadOnly="items.length == 0"
                v-bind:Label="$t('Shared.Report')"
                v-bind:Name="'btnpatientlist'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="showReportFilter()"/>
        </div>

        <ItemsReceivedListRep v-if="isReportVisible" 
            :recNo="recNoToReport"
            :closeWindow="closeParamRepWindow"
        />

        <ItemsReceivedFiltersRep
            v-if="isReportFilterVisible"
            :visible="isReportFilterVisible"
            :closeWindow="closeParamRepWindow"
            @close="closeParamRepWindow"
        />
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';
import ePharmacyItemsReceivedService from '@/services/epharmacyitemsreceived.service';
import ePharmacyLocationsService from '@/services/epharmacylocation.service';
import Utils from "@/common/utils";

export default {
    name: 'ePharmacyItemsReceivedList',
    mixins: [DBFunctions, ShowMessage],

    data() {
        return {
            ItemCodeModel: [],
             OptionsRightMenu:{
                visible:false,
                btnvisible:false,
                ItemsList:[],
                favButtonAtion: false
            },  
            BaseFields:[{ key: 'description', sortable: true, label: this.$t('Shared.Description') },{ key: 'itemCode', sortable: true, label: this.$t('Shared.Code')}],
            fields: [
                { key: 'batchno', sortable: true, label: this.$t('Shared.TransactionNo'), class: 'text-rigth' },       
                { key: 'receiveddate', sortable: true, label: this.$t('Shared.ReceivedDate'), class: 'text-rigth' }, 
                { key: 'invoiceNumber', sortable: true, label: this.$t('Shared.InvoiceNumber'), class: 'text-rigth'},       
                { key: 'ponumber', sortable: true, label: this.$t('Shared.PoNumber'), class: 'text-rigth' },      
                { key: 'vendor', sortable: true, label: this.$t('Shared.Vendor'), class: 'text-rigth', formatter: (value) => { return value?.name ?? ''}  },
                { key: 'comments', sortable: true, label: this.$t('Shared.Comments'), class: 'text-rigth' },        
            ],           
            fieldsDate: ['receiveddate'],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: null,
            filterOn: [],
            items: [],
            isReadOnly: false,
            isDateFromValid: true,
            isDateToValid: true,
            DateFrom: null,
            DateTo: null,
            ShowMessageIsEmpty: '',
            parameter:{
                SearchCriteria:'',
                DateFrom: null,
                DateTo: null,
                IsVoid: false,
                PageNumber : 1,
                PageSize: 0,
                Location: [],
                ItemCodeList: [],
                BuildingRestriction: this.$store.state.restrictions.buildingLocation,
                PharmacyRestriction: this.$store.state.restrictions.pharmacy
            },
            pharmacyLocations: [],
            selectPlaceholder: this.$t('Shared.SelectOptions'),
            locationModel: null,
            isReportVisible: false,
            isReportFilterVisible: false,
            recNoToReport: null,
        };
    },

    methods: {
        getValuesItems(value) {
            this.ItemCodeModel = value;
            this.parameter.ItemCodeList = value;
            this.currentPage = 1;
            this.SearchItemsReceived();
        },
        ChangeFilter(m){      
            this.modelFilter = m;
        },
        AddItemReceived() {
            this.$router
                .push({ name: "ePharmacyItemsReceivedAdd" })
                .catch(err => { 
                    if (err && err.name !== 'NavigationDuplicated') { 
                        console.error('Error al navegar:', err); 
                    } 
                });
        },

        EditItemReceived(item) {
            this.$router.push({ name: "ePharmacyItemsReceivedEdit", params: {recId: item.recID} })
        },

        DateFromChange(value) {
            this.parameter.DateFrom = value;            
        },

        DateToChange(value) {
            this.parameter.DateTo = value;           
        },

        SearchItemsReceived() {
            if (!this.validateForm()) return;
            
            this.parameter.PageSize = this.perPage;           
            this.parameter.DateFrom = this.DateFrom;
            this.parameter.DateTo= this.DateTo;  
            ePharmacyItemsReceivedService.getAll(this.parameter)
                    .then((response) => {
                        if(response.status == '200' && response.data){
                            this.items = response.data;                           
                            this.items.forEach(element => {
                                let { receiveddate } = element
                                if (receiveddate) element.receiveddate = Utils.formatterDateToString(receiveddate);        
                            });
                            
                            let headerString = response.headers["x-pagination"];
                            this.Header = JSON.parse(headerString);
                            this.totalRows = this.Header.TotalCount;
                        } 
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
        },

        onRowSelected() {

        },

        onFiltered() {

        },

        showReport(item) {
            if(this.items.length > 0){
                if (item && item.recID) {
                    this.recNoToReport = item.recID
                }
                this.isReportVisible = true
            }
        },

        showReportFilter() {
            this.isReportFilterVisible = true
        },

        closeParamRepWindow() {
            this.isReportFilterVisible = false
            this.isReportVisible = false
        },

        pageChanged (page) {            
            this.currentPage = page;    
            this.SearchItemsReceived();     
        },

        PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.SearchItemsReceived();  
        },

        getPharmacyLocations() {
            const parameter ={
                PageSize: 0,
                PageNumber: 0,
                FilterByEmployee: true,
                BuildingRestriction: this.$store.state.restrictions.buildingLocation,
                PharmacyRestriction: this.$store.state.restrictions.pharmacy
            }

            this.pharmacyLocations = [];
            ePharmacyLocationsService.getAll(parameter)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.pharmacyLocations = response.data;
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        ChangeDropDownLocation(values){
            this.parameter.Location = [];
            
           /* if (value && value.length > 0) {
                locations = value.map(x => x.code).join(',');
            }*/

            
        values.forEach(x => {
          this.parameter.Location.push(x.code)
        });
            
          //  this.parameter.Location = locations; 
            this.currentPage = 1;
            this.SearchItemsReceived();
        },

        validate_date_range() {
            return Utils.isDateFromAndDateTo(this.DateFrom, this.DateTo);
        },

        // Método de validación reutilizable
        validateForm() {
            const isValid = this.validate_date_range();
        
            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;
            
            // Forzar actualización del componente
            this.$forceUpdate();
            
            if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
                return false;
            }
            return true;
        },
    },

   created() {    
        this.getPharmacyLocations();
        this.SearchItemsReceived();
    },

     mounted(){

        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;    
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
        case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }       
    }
}
</script>